import { render, staticRenderFns } from "./StockVerification.vue?vue&type=template&id=16aa8566&"
import script from "./StockVerification.vue?vue&type=script&lang=ts&"
export * from "./StockVerification.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports